module.exports = __webpack_public_path__ + "static/img/shanchu2.d0bbb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/shanchu2.png
// module id = X2Az
// module chunks = 24